<template>
  <!--//@*/*
      //    *RPD  App v0.91
      //    * Copyright (c) 2022, Blue Cover Six LLC .John Molt All rights reserved.
      //    Code licensed under contract To Reno Police Department / City of Reno, in perpetuity
      //    */
      //-->
  <v-expansion-panel popout class="mt-0">
    <v-expansion-panel-header
      id="rec_pub_recs_req"
      @click="onExpansionPanelClick"
      class="accent white-text text-body2 text-md-h6"
      >FAQ Section
      <template v-slot:actions>
        <v-icon color="white" x-large> $expand </v-icon>
      </template></v-expansion-panel-header
    >
    <v-expansion-panel-content color="grey lighten-5">
      <v-card shaped class="mt-4">
        <v-card-title>
          <h4>FAQ Section</h4>
        </v-card-title>
        <v-card-text>
          <div style="font-size: 1.3rem !important;">
       <p><i>How is my privacy protected?</i></p>
       <p style="padding-top: 0;">The intent of the drone program is to enhance our response to emergency calls 
        for service. As such, drones are used during an active response to an emergency
         or other call for police/fire assistance. Our policy prohibits drone operators 
         from intentionally recording or transmitting images of any location where a 
         person would have a reasonable expectation of privacy, such as inside private 
         buildings, except where authorized by a warrant issued by a judge or in exigent
          circumstances.
        </p>
        <p><i>What is a drone/sUAS?</i></p>
        <p style="padding-top: 0;">Small unmanned aircraft system
          (small UAS) means a small unmanned aircraft and its 
          associated elements (including communication links and the components
          that control the small unmanned aircraft) that are required for the 
          safe and efficient operation of the small unmanned aircraft in the
          national airspace system.
          <span style="font-size: 0.8rem !important;">FAR Part 107.3</span> 
        </p>
        <p><i>What rules must an RPD pilot follow?</i></p>
        <p style="padding-top: 0;">All Reno Police Department pilots are 
          subject to FAA regulations and must have a valid FAR Part 107 
          Remote Pilot Certificate. Additionally, those pilots who are operating
           the Drone as a First Responder platforms must be NIST certified.
        </p>


</div>
        </v-card-text>
      </v-card>

    </v-expansion-panel-content>
  </v-expansion-panel>
</template>
<style lang="scss" scoped>
@import "../scss/site.scss";
border-img {
  border: 1px solid black;
}
.div-login-page-img {
  margin: 0;
}
.letter_img {
  width: 100%;
  margin-left: 0 !important;
}
.login-page-img {
  width: 100%;
  margin-left: 0 !important;
}
p {
  font-weight: 600;
  padding: 12px;
}
a {
  color: blue;
}
a:visited {
  color: rgb(2, 2, 32);
}
.bcs-expansion-content {
  color: black;
}
.basic-interior-card {
  min-height: 100px;
}
@media (min-width: 768px) {
  .login-page-img {
    max-width: 300px;
  }
  .letter_img {
    max-width: 436px;
  }
}
</style>
<script>
import { bus_common } from "../mixins/bus_common";
export default {
  name: "content2",
  mixins: [bus_common],
  data: function () {
    return {
      isActive1: false,
    };
  },
  watch: {},
  computed: {},
  methods: {
    onExpansionPanelClick(event) {
      this.$emit("onExpansionPanelClick", event);
    },
    init: function () {
      this.show_loader(false);
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.init();
      // The whole view is rendered, so I can safely access or query
      // the DOM. ¯\_(ツ)_/¯
    });
  },
};
</script>
